var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-5" },
      [
        _c(
          "base-card",
          {
            attrs: {
              overflowVisible: "",
              title: _vm.$t("cycleControl"),
              info: _vm.tooltipText,
              hideButtons: _vm.historyReadOnly
            },
            on: {
              rightBtnClick: function($event) {
                _vm.showAddSection = true
              }
            }
          },
          [
            !_vm.showAddSection
              ? _c(
                  "template",
                  {
                    slot:
                      _vm.$uiHelpers.isMobile || _vm.$uiHelpers.isTablet
                        ? "append-btn-title"
                        : "right-button"
                  },
                  [
                    _c("add-button", {
                      attrs: { buttonText: _vm.$t("new-cycle") },
                      on: { click: _vm.addNewCycleForm }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAddSection
              ? _c(
                  "form",
                  {
                    staticClass:
                      "d-flex flex-column flex-md-row align-items-start form-section",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.addNewCycleForm.apply(null, arguments)
                      }
                    }
                  },
                  [
                    !_vm.allowAdd
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("mustSetPeriod")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowAdd
                      ? _c(
                          "b-col",
                          {
                            staticClass: "mb-2 mb-md-0 mx-md-2",
                            attrs: { cols: "12", md: "3" }
                          },
                          [
                            _c("base-datepicker", {
                              attrs: {
                                max: new Date(),
                                placeholder: _vm.$t("cycleStartDate"),
                                "value-as-date": ""
                              },
                              model: {
                                value: _vm.startDate,
                                callback: function($$v) {
                                  _vm.startDate = $$v
                                },
                                expression: "startDate"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "add-text",
                                on: {
                                  click: function() {
                                    return (_vm.showAddSection = false)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("back")))]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.allowAdd
                      ? _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex justify-content-md-start justify-content-center",
                            attrs: { cols: "12" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "submit",
                                  disabled: !_vm.startDate
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("startCycle")))]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.cycles.length > 0
              ? _c("div", { staticClass: "results mt-4" }, [
                  _c(
                    "ul",
                    { staticClass: "cycle-item" },
                    [
                      _c("h4", [_vm._v(_vm._s(_vm.$t("historyCycle")))]),
                      _vm._v(" "),
                      _vm._l(_vm.cycles, function(cycle) {
                        return _c(
                          "li",
                          { key: cycle.idCycle, staticClass: "cycle-card" },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.$t("cycle")) +
                                  " " +
                                  _vm._s(
                                    cycle.cycleDuration
                                      ? _vm.formatDate(cycle.dateStartCycle)
                                      : _vm.$t("current") +
                                          " " +
                                          _vm.formatDate(cycle.dateStartCycle)
                                  ) +
                                  " " +
                                  _vm._s(
                                    cycle.cycleDuration != null
                                      ? _vm.$t("until") +
                                          " " +
                                          _vm.formatDate(
                                            _vm.addDaysToDate(
                                              cycle.dateStartCycle,
                                              cycle.cycleDuration
                                            )
                                          )
                                      : ""
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            cycle.cycleDuration
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("cycleDuration2")) +
                                      ": " +
                                      _vm._s(cycle.cycleDuration) +
                                      " " +
                                      _vm._s(_vm.$t("days"))
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            cycle.periodDuration
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("periodDuration2")) +
                                        ": " +
                                        _vm._s(cycle.periodDuration) +
                                        " " +
                                        _vm._s(_vm.$t("days"))
                                    )
                                  ])
                                ])
                              : _c("div", [
                                  !_vm.visibleSetPeriod
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "btn btn-secondary btn-background",
                                          on: {
                                            click: function($event) {
                                              return _vm.setVisiblePeriodLength()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("setPeriodDuration"))
                                          )
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "b-col",
                                            {
                                              staticClass:
                                                "mb-2 mb-md-0 mx-md-2 input-container",
                                              attrs: { cols: "12", md: "3" }
                                            },
                                            [
                                              _c(
                                                "base-input",
                                                {
                                                  staticClass: "inputAnswer",
                                                  attrs: {
                                                    min: "0",
                                                    type: "number",
                                                    placeholder: _vm.$t(
                                                      "periodDuration2"
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.periodDuration,
                                                    callback: function($$v) {
                                                      _vm.periodDuration = $$v
                                                    },
                                                    expression: "periodDuration"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "append" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "days-text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("days")
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ],
                                                2
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "add-text",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.setPeriodDuration(
                                                        cycle
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("add-txt"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ]),
                            _vm._v(" "),
                            cycle.cycleDuration
                              ? _c("div", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("ovulationDuration")) +
                                      ": " +
                                      _vm._s(
                                        _vm
                                          .calculateOvulationMonthDays(
                                            cycle.dateStartCycle,
                                            cycle.cycleDuration
                                          )
                                          .join(", ")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _c("div", [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("ovulationDurationPrediction")
                                      ) +
                                        ": " +
                                        _vm._s(_vm.displayFertileDays())
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("newCyclePredictionDate")) +
                                        ": " +
                                        _vm._s(
                                          _vm.formatDate(_vm.newCyclePrediction)
                                        )
                                    )
                                  ])
                                ]),
                            _vm._v(" "),
                            _c("CycleChart", {
                              attrs: {
                                startDate: cycle.dateStartCycle,
                                cycleLength: cycle.cycleDuration,
                                predictedCycleLength: _vm.calculateAverageCycleLength(),
                                periodLength: cycle.periodDuration
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "delete-text",
                                on: {
                                  click: function($event) {
                                    return _vm.deleteCycle(cycle.idCycle)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ])
              : _c("div", { staticClass: "no-cycles" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("noControl")))])
                ]),
            _vm._v(" "),
            _c("base-dialog", {
              attrs: {
                content: _vm.$t("confirmEndCurrentCycle"),
                okFn: function async() {
                  _vm.endCurrentCycle()
                },
                cancelFn: function() {
                  _vm.visibleEndCurrentCycle = false
                }
              },
              model: {
                value: _vm.visibleEndCurrentCycle,
                callback: function($$v) {
                  _vm.visibleEndCurrentCycle = $$v
                },
                expression: "visibleEndCurrentCycle"
              }
            })
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-93008142", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93008142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/clinicHistory/MenstrualCalendar.vue
// module id = 4079
// module chunks = 74